package gr.tech.GRAttestation.models.api

import kotlinx.serialization.Serializable

@Serializable
data class ApiResponse<T>(
    val success: Boolean,
    val message: String = "",
    val data: T? = null,
    val error: ApiError = ApiError(
        code = "internal_error",
        message = "Please try again later."
    )
)

@Serializable
data class ApiError(
    val code: String,            // e.g., "email_taken", "invalid_password"
    val message: String          // user-friendly or dev-friendly (depends on context)
)
